export default {
  页面曝光: {
    f_module: '页面曝光',
    f_resource: '小企鹅cny2021',
    f_type: 0
  },
  头图: {
    头图: {
      f_module: '头图',
      f_resource: '头图',
      f_type: 1
    },
    头像: {
      f_module: '头图',
      f_resource: '头像',
      f_type: 3
    },
    规则: {
      f_module: '头图',
      f_resource: '规则',
      f_type: 4
    }
  },
  红包: {
    红包: {
      f_module: '红包模块',
      f_resource: '吸底banner',
      f_type: 1
    },
    头像: {
      f_module: '红包模块',
      f_resource: '头像',
      f_type: 3
    },
    历史红包: {
      f_module: '红包模块',
      f_resource: '历史红包',
      f_type: 4
    },
    领取红包: {
      f_module: '红包模块',
      f_resource: '领取红包',
      f_type: 4
    },
    红包领完: {
      f_module: '红包模块',
      f_resource: '红包领完',
      f_type: 4
    }
  },
  福袋: {
    福袋模块: {
      f_module: '福袋模块',
      f_resource: '福袋模块',
      f_type: 1
    },
    查看: {
      f_module: '福袋模块',
      f_resource: '福袋模块',
      f_type: 4
    }
  },
  vip5折模块: {
    vip5折模块: {
      f_module: 'vip5折模块',
      f_resource: 'vip5折模块',
      f_type: 1
    },
    年卡开通: {
      f_module: 'vip5折模块',
      f_resource: '年卡开通',
      f_type: 4
    },
    月卡开通: {
      f_module: 'vip5折模块',
      f_resource: '月卡开通',
      f_type: 4
    },
    季卡开通: {
      f_module: 'vip5折模块',
      f_resource: '季卡开通',
      f_type: 4
    }
  },
  内容展示: {
    内容模块: {
      f_module: '内容模块',
      f_resource: '内容模块',
      f_type: 1
    },
    主站活动banner: {
      f_module: '主站活动模块',
      f_resource: '主站活动banner',
      f_type: 5
    }
  },
  斗牛模块: {
    斗牛模块: {
      f_module: '斗牛模块',
      f_resource: '斗牛模块',
      f_type: 1
    },
    登录: {
      f_module: '斗牛模块',
      f_resource: '登录',
      f_type: 4
    },
    领取: {
      f_module: '斗牛模块',
      f_resource: '领取',
      f_type: 4
    },
    去斗牛: {
      f_module: '斗牛模块',
      f_resource: '去斗牛',
      f_type: 4
    }
  },
  红包分享浮层: {
    红包分享浮层: {
      f_module: '红包分享浮层',
      f_resource: '红包分享浮层',
      f_type: 1
    },
    关闭: {
      f_module: '红包领取浮层',
      f_resource: '关闭',
      f_type: 4
    },
    我知道了: {
      f_module: '红包领取浮层',
      f_resource: '我知道了',
      f_type: 4
    }
  },
  小企鹅介绍: {
    小企鹅介绍: {
      f_module: '小企鹅介绍模块',
      f_resource: '小企鹅介绍',
      f_type: 1
    },
    小企鹅介绍图片: {
      f_module: '小企鹅介绍模块',
      f_resource: '小企鹅介绍图片',
      f_type: 3
    },
    底部logo: {
      f_module: '小企鹅介绍模块',
      f_resource: '底部logo',
      f_type: 3
    }
  },
  福袋查询: {
    查询失败: {
      f_module: '福袋查询',
      f_resource: '查询失败',
      f_type: 3
    },
    可以抽奖: {
      f_module: '福袋查询',
      f_resource: '可以抽奖',
      f_type: 3
    },
    不可以抽奖: {
      f_module: '福袋查询',
      f_resource: '不可以抽奖',
      f_type: 3
    }
  },
  领取福袋浮层: {
    领取福袋浮层: {
      f_module: '领取福袋浮层',
      f_resource: '领取福袋浮层',
      f_type: 1
    },
    返回活动: {
      f_module: '领取福袋浮层',
      f_resource: '返回活动',
      f_type: 4
    },
    关闭: {
      f_module: '领取福袋浮层',
      f_resource: '关闭',
      f_type: 4
    }
  },
  红包领取浮层: {
    红包领取浮层: {
      f_module: '红包领取浮层',
      f_resource: '红包领取浮层',
      f_type: 1
    },
    开红包: {
      f_module: '红包领取浮层',
      f_resource: '开红包',
      f_type: 4
    },
    关闭: {
      f_module: '红包领取浮层',
      f_resource: '关闭',
      f_type: 4
    },
    我知道了: {
      f_module: '红包领取浮层',
      f_resource: '我知道了',
      f_type: 4
    }
  },
  领取异常浮层: {
    领取异常浮层: {
      f_module: '领取异常浮层',
      f_resource: '领取异常浮层',
      f_type: 1
    },
    关闭: {
      f_module: '领取异常浮层',
      f_resource: '关闭',
      f_type: 4
    },
    我知道了: {
      f_module: '领取异常浮层',
      f_resource: '我知道了',
      f_type: 4
    },
    看大家: {
      f_module: '领取异常浮层',
      f_resource: '看大家',
      f_type: 4
    }
  },
  成功领取红包浮层: {
    成功领取红包浮层: {
      f_module: '成功领取红包浮层',
      f_resource: '成功领取红包浮层',
      f_type: 1
    },
    关闭: {
      f_module: '成功领取红包浮层',
      f_resource: '关闭',
      f_type: 4
    },
    查看他人: {
      f_module: '成功领取红包浮层',
      f_resource: '查看他人',
      f_type: 3
    },
    继续发红包: {
      f_module: '成功领取红包浮层',
      f_resource: '继续发红包',
      f_type: 4
    }
  },
  红包领取进展浮层: {
    红包领取进展浮层: {
      f_module: '红包领取进展浮层',
      f_resource: '红包领取进展浮层',
      f_type: 1
    },
    关闭: {
      f_module: '红包领取进展浮层',
      f_resource: '关闭',
      f_type: 4
    },
    继续发红包: {
      f_module: '红包领取进展浮层',
      f_resource: '继续发红包',
      f_type: 4
    },
    福袋已到账: {
      f_module: '红包领取进展浮层',
      f_resource: '福袋已到账',
      f_type: 4
    },
    返回活动: {
      f_module: '红包领取进展浮层',
      f_resource: '返回活动',
      f_type: 4
    }
  },
  账号风险浮层: {
    账号风险浮层: {
      f_module: '账号风险浮层',
      f_resource: '账号风险浮层',
      f_type: 1
    },
    我知道了: {
      f_module: '账号风险浮层',
      f_resource: '我知道了',
      f_type: 4
    }
  },
  双账号校验: {
    双账号校验: {
      f_module: '双账号校验',
      f_resource: '双账号校验',
      f_type: 1
    },
    保持登录: {
      f_module: '双账号校验',
      f_resource: '保持登录',
      f_type: 4
    },
    切换账号: {
      f_module: '双账号校验',
      f_resource: '切换账号',
      f_type: 4
    }
  },
  外来获得斗牛资格浮层: {
    外来获得斗牛资格浮层: {
      f_module: '外来获得斗牛资格浮层',
      f_resource: '外来获得斗牛资格浮层',
      f_type: 1
    },
    去小企鹅活动: {
      f_module: '外来获得斗牛资格浮层',
      f_resource: '去小企鹅活动',
      f_type: 4
    },
    回腾讯视频: {
      f_module: '外来获得斗牛资格浮层',
      f_resource: '回腾讯视频',
      f_type: 4
    }
  },
  活动规则浮层: {
    外来获得斗牛资格浮层: {
      f_module: '活动规则浮层',
      f_resource: '活动规则浮层',
      f_type: 1
    },
    返回活动: {
      f_module: '活动规则浮层',
      f_resource: '返回活动',
      f_type: 4
    },
    关闭: {
      f_module: '活动规则浮层',
      f_resource: '关闭',
      f_type: 4
    }
  },
  斗牛floating: {
    斗牛floating: {
      f_module: '头图',
      f_resource: '斗牛floating',
      f_type: 4
    }
  }
};